import { DuplicateCheckable } from '@lib/utils/chooseMediaUtils';
import { memo } from 'react';
import css from './MediaDataGrid.module.scss';

export interface DuplicateStatusProps<T extends DuplicateCheckable = DuplicateCheckable> {
  item: T;
  isDuplicate: (item: T) => boolean;
  showBadge?: boolean;
  showIcon?: boolean;
}

/**
 * Component for displaying duplicate status of media items
 * Can show as a badge, icon, or both
 * Generic to work with any type that implements DuplicateCheckable
 */
export const DuplicateStatus = memo(
  <T extends DuplicateCheckable>({
    item,
    isDuplicate,
    showBadge = true,
    showIcon = false,
  }: DuplicateStatusProps<T>) => {
    const isItemDuplicate = isDuplicate(item);

    if (!isItemDuplicate) return null;

    return (
      <>
        {showBadge && <span className={css.inLibraryBadge}>In library</span>}
        {showIcon && <span className={css.duplicateCell}>✓</span>}
      </>
    );
  },
);

DuplicateStatus.displayName = 'DuplicateStatus';
